import type { Source } from "@/hooks/use-sources";

export type SourceCategory = "failed" | "notProcessed" | "processing" | "processed";

const CANCEL_SENTINEL = "cancelled by user";

/**
 * Classify a source for list display. The four categories drive both the
 * grouping (Failed / Not Yet Processed / Processed) and the per-row
 * sub-line copy + action button.
 *
 * Discrimination rules:
 *  - latestRun.status === 'running'                        → processing
 *  - latestRun.status === 'failed' && cancel sentinel      → notProcessed
 *  - latestRun.status === 'failed'                         → failed
 *  - latestRun.status === 'succeeded'                      → processed
 *  - no latestRun                                          → notProcessed
 */
export function categorizeSource(source: Source): SourceCategory {
  const run = source.latestRun;
  if (!run) return "notProcessed";
  if (run.status === "running") return "processing";
  if (run.status === "succeeded") return "processed";
  // failed
  if (run.errorMessage === CANCEL_SENTINEL) return "notProcessed";
  return "failed";
}
